import {
  Zap, Boxes, Users, UserCircle2, CreditCard, Cloud,
  Settings2, BarChart3, Percent, Barcode, Printer,
  UtensilsCrossed, ShoppingCart, Wallet, Mic,
} from "lucide-react";
import Reveal from "../Reveal";

const features = [
  { icon: Zap,             title: "Easy Billing",          desc: "Create invoices in seconds",        bg: "from-blue-100 to-blue-50",       fg: "text-blue-700" },
  { icon: Boxes,           title: "Inventory Management",   desc: "Track stock, low-stock alerts",     bg: "from-emerald-100 to-emerald-50", fg: "text-emerald-600" },
  { icon: UserCircle2,     title: "Customer Management",    desc: "Maintain customer database",        bg: "from-pink-100 to-pink-50",       fg: "text-pink-600" },
  { icon: BarChart3,       title: "Reports & Analytics",    desc: "Daily sales, profits, insights",    bg: "from-amber-100 to-amber-50",     fg: "text-amber-600" },
  { icon: CreditCard,      title: "Multiple Payments",      desc: "Cash, UPI, Card & more",            bg: "from-violet-100 to-violet-50",   fg: "text-violet-700" },
  { icon: Cloud,           title: "Cloud Backup",           desc: "Secure your data in the cloud",     bg: "from-sky-100 to-sky-50",         fg: "text-sky-700" },
  { icon: Users,           title: "Multi-User Access",      desc: "Add staff & manage permissions",    bg: "from-teal-100 to-teal-50",       fg: "text-teal-700" },
  { icon: Settings2,       title: "Customizable",           desc: "Tailor the app to fit your shop",   bg: "from-orange-100 to-orange-50",   fg: "text-orange-600" },
  { icon: Mic,             title: "AI Voice Item Picker",   desc: "Add items hands-free using voice",  bg: "from-fuchsia-100 to-fuchsia-50", fg: "text-fuchsia-700", featured: true },
  { icon: Percent,         title: "Offers & Discounts",     desc: "Coupons, price rules & promotions", bg: "from-blue-100 to-blue-50",       fg: "text-blue-700" },
  { icon: Barcode,         title: "Barcode Support",        desc: "Generate, print & scan barcodes",   bg: "from-slate-100 to-slate-50",     fg: "text-slate-700" },
  { icon: Printer,         title: "Thermal Printer",        desc: "58mm & 80mm printer ready",         bg: "from-rose-100 to-rose-50",       fg: "text-rose-600" },
  { icon: UtensilsCrossed, title: "Restaurant & Cafe",      desc: "Tables, KOT, modifiers, splits",    bg: "from-lime-100 to-lime-50",       fg: "text-lime-700" },
  { icon: ShoppingCart,    title: "Supermarket POS",        desc: "Scale integration & MRP control",   bg: "from-cyan-100 to-cyan-50",       fg: "text-cyan-700" },
  { icon: Wallet,          title: "Expense Tracking",       desc: "Capture every rupee spent",         bg: "from-indigo-100 to-indigo-50",   fg: "text-indigo-700" },
];

export default function Features() {
  return (
    <section id="features" data-testid="features-section" className="relative py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <Reveal delay={80}>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-navy">
              Powerful Features for Your Business
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
              Everything FolioStax brings to your counter — from blazing-fast billing to AI-assisted
              ordering.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-10">
          {features.map((f, i) => (
            <Reveal
              key={f.title}
              delay={(i % 5) * 60}
              className="group flex flex-col items-center text-center"
              {...{}}
            >
              <div
                data-testid={`feature-card-${i}`}
                className={`relative h-16 w-16 rounded-2xl bg-gradient-to-br ${f.bg} grid place-items-center shadow-sm group-hover:shadow-md group-hover:-translate-y-1 transition-all duration-300 ${f.featured ? "ring-2 ring-blue-800/30" : ""}`}
              >
                <f.icon className={`h-7 w-7 ${f.fg}`} />
                {f.featured && (
                  <span className="absolute -top-2 -right-2 text-[9px] font-bold uppercase tracking-wider bg-blue-800 text-white px-2 py-0.5 rounded-full shadow">
                    New
                  </span>
                )}
              </div>
              <p className="mt-4 font-display font-bold text-navy text-[15px] leading-tight">
                {f.title}
              </p>
              <p className="mt-1.5 text-xs text-slate-500 leading-relaxed max-w-[180px]">
                {f.desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
